function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#5b2966"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.6257,
  cy: 2.8184,
  rx: 2.3837,
  ry: 1.4831,
  strokeWidth: 0.37042
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.6257,
  cy: 2.8184,
  r: 0.91406,
  strokeWidth: 0.37042
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.1829 0.33157 2.695 4.6425",
  strokeWidth: 0.74084
}));

function SvgEyeOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 5.2917 5.2917",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye_off.bc953cfe11f88bf40cccfe284b193825.svg";
export { ForwardRef as ReactComponent };